import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from '../../../../Services/auth.service';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-create-user',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, RouterOutlet,NgIf],
  templateUrl: './create-user.component.html',
  styleUrl: './create-user.component.css'
})
export class CreateUserComponent{

  isStaff:any;

  constructor(private authService:AuthService){}
  
  ngOnInit(){
    this.getUserRole();
  }

  getUserRole(){
    this.isStaff = this.authService.getUserRole();
  }
}
